import {
  ProductSearchResultsPageHitV1,
  ProductSearchResultsSearchAssistantV1,
  SelectItemProductSearchResultsClickV1,
} from '@inditex/resellanl-ianalytics-events';
import { buildEvent } from '../helpers/build-event';
import { normalizeUniverse } from '../helpers/normalize-universe';

export const PRODUCT_SEARCH_RESULTS_PAGE_HIT = ({ data }: { data?: unknown }) => {
  const payload = data as {
    universe?: string;
  };

  const event = buildEvent({
    Event: ProductSearchResultsPageHitV1,
    payload: {
      universe: normalizeUniverse(payload?.universe),
    },
  });

  return event;
};

// searchRequestProvider is BLOCKED (PREOWNED-42260): real provider value pending team confirmation.
const SEARCH_REQUEST_PROVIDER = 'mic-preownedsearchengine';

export const PRODUCT_SEARCH_RESULTS_SEARCH_ASSISTANT = ({ data }: { data?: unknown }) => {
  const payload = data as {
    universe?: string;
    searchRequestQuery?: string;
    searchRequestResultsNum?: number | null;
    searchRequestType?: 'manual' | 'filters';
  };

  const event = buildEvent({
    Event: ProductSearchResultsSearchAssistantV1,
    payload: {
      universe: normalizeUniverse(payload?.universe),
      searchRequestProvider: SEARCH_REQUEST_PROVIDER,
      searchRequestQuery: payload?.searchRequestQuery ?? '',
      searchRequestResultsNum: payload?.searchRequestResultsNum ?? null,
      searchRequestType: payload?.searchRequestType ?? 'manual',
    },
  });

  return event;
};

export const SELECT_ITEM_PRODUCT_SEARCH_RESULTS_CLICK = ({ data }: { data?: unknown }) => {
  const payload = data as {
    universe?: string;
    listPosition?: number | string;
    productGroupId?: number | null;
    productId?: number | string;
    section?: string;
  };

  const event = buildEvent({
    Event: SelectItemProductSearchResultsClickV1,
    payload: {
      universe: normalizeUniverse(payload?.universe),
      listPosition: Number(payload?.listPosition),
      productGroupId: payload?.productGroupId ?? null,
      productId: Number(payload?.productId),
      section: normalizeUniverse(payload?.section),
    },
  });

  return event;
};
